import type { LoomductConfig } from '../core/types'
import type { WebAnalyticsOptions } from '../web-analytics'

export function readScriptConfig(script: HTMLScriptElement): {
  config: LoomductConfig
  webAnalytics: WebAnalyticsOptions
  plugins: string[]
  manualLoad: boolean
} {
  const value = (name: string) => script.getAttribute(`data-${name}`)
  const flag = (name: string) => value(name) !== null && value(name) !== 'false'
  const list = (name: string) =>
    (value(name) ?? '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
  const downloads = list('file-downloads')
  return {
    config: {
      token: value('token') ?? '',
      host: value('host') ?? undefined,
      debug: flag('debug'),
      allowLocalhost: flag('allow-localhost'),
      allowAutomation: flag('allow-automation'),
      hashRouting: flag('hash-routing'),
      urlParams: list('url-params'),
    },
    webAnalytics: {
      autoPageviews: value('auto-pageviews') !== 'false',
      outboundLinks: flag('outbound-links'),
      fileDownloads:
        downloads[0] && downloads[0] !== 'false'
          ? downloads
          : flag('file-downloads'),
      dataAttributes: flag('click-events'),
    },
    plugins: ['client-hints', 'web-vitals'].filter(flag),
    manualLoad: flag('manual-load'),
  }
}

export function findPluginBase(
  src: string,
  version: string,
): string | undefined {
  try {
    const url = new URL(src, location.href)
    const jsdelivr = url.host === 'cdn.jsdelivr.net'
    const path = jsdelivr ? url.pathname.slice(4) : url.pathname
    const rest = path.slice(13)
    if (url.protocol !== 'https:' && url.origin !== location.origin) {
      return undefined
    }
    if (
      (jsdelivr || url.host === 'unpkg.com') &&
      path.startsWith('/@loomduct/js') &&
      (!rest || rest.startsWith('@') || rest.startsWith('/'))
    ) {
      return `https://${url.host}${jsdelivr ? '/npm' : ''}/@loomduct/js@${version}/dist/cdn/`
    }
    return url.origin + url.pathname.slice(0, url.pathname.lastIndexOf('/') + 1)
  } catch {
    return undefined
  }
}
